module.exports = __webpack_public_path__ + "media/public/img/getyourguide-review-icon-01-fb3e5192162012389e870f98922b8d7a.svg";